import * as Net from 'util/Net';

export function setAgentFoundryHumanActionItemDone(
  agentFoundryId: string,
  itemId: string,
  isDone: boolean
): Promise<{agentFoundryId: string}> {
  return Net.postJSONPromise({
    url: `/1/api/llm/agent-foundries/${agentFoundryId}:set-human-action-item-done`,
    data: {itemId, isDone},
  });
}

export interface ArchiveAgentFoundryResult {
  agentFoundryId: string;
  archivedAgentIds: Array<string>;
  pausedAgentIds: Array<string>;
  skippedAgentIds: Array<string>;
}

export function archiveAgentFoundry(
  agentFoundryId: string,
  {reason, archiveAgents}: {reason: string; archiveAgents: boolean}
): Promise<ArchiveAgentFoundryResult> {
  return Net.postJSONPromise({
    url: `/1/api/llm/agent-foundries/${agentFoundryId}:archive`,
    data: {reason, archiveAgents},
  });
}

export function unarchiveAgentFoundry(agentFoundryId: string): Promise<{agentFoundryId: string}> {
  return Net.postJSONPromise({url: `/1/api/llm/agent-foundries/${agentFoundryId}:unarchive`, data: {}});
}
